import { jsx as n, jsxs as p } from "@emotion/react/jsx-runtime";
import { Stack as l, FontAwesomeIconsPartooUsed as f, IconPrefix as m } from "@partoohub/ui";
import { StyledButton as u } from "./PageButton.styled.js";
import { ConditionalResetIcon as h } from "../../ConditionalResetIcon/ConditionalResetIcon.js";
const y = ({
  dataTrackId: o,
  buttonText: r,
  disabled: e = !1,
  onClick: s,
  onReset: t
}) => {
  const a = !!t, c = (i) => {
    i.stopPropagation(), e || t?.();
  };
  return /* @__PURE__ */ n(u, { dataTrackId: o, disabled: e, type: "button", variant: "secondary", appearance: "outlined", shape: "cube", onClick: s, children: /* @__PURE__ */ p(l, { direction: "row", justifyContent: "space-between", alignItems: "center", children: [
    r,
    /* @__PURE__ */ n(h, { dataTrackId: o, applyDefaultColor: !0, iconSize: "14px", caretIcon: [f.faCaretDown, m.SOLID], showReset: a, onReset: c })
  ] }) });
};
export {
  y as PageButton
};
